
import { computed, defineComponent, ref } from "vue";
import AppHeading from "@/components/UI/AppHeading.vue";
import BananoShape from "@/components/UI/BananoShape.vue";
import ImageLoader from "@/components/UI/ImageLoader.vue";
import { storeUtil } from "@/store";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Sidebar",
  components: {
    AppHeading,
    BananoShape,
    ImageLoader,
  },

  setup() {
    const router = useRouter();

    const seed = computed(storeUtil.getters.seed);
    const accounts = computed(storeUtil.getters.accounts);
    const address = computed(() => {
      const route = router.currentRoute.value;
      if (route.name === "Account") return route.params.banAddress as string;
      else return null;
    });

    const loadingNewAccount = ref(false);
    const addAccount = async () => {
      loadingNewAccount.value = true;
      await storeUtil.mutations.addAccount();
      loadingNewAccount.value = false;
    };

    const goToAccount = (address: string) => {
      router.push({
        name: "Account",
        params: {
          banAddress: address,
        },
      });
    };

    const login = () => {
      router.push({
        name: "Home",
        query: {
          redirect: router.currentRoute.value.fullPath,
        },
      });
    };

    return {
      seed,
      accounts,
      address,
      loadingNewAccount,
      addAccount,
      goToAccount,
      login,
    };
  },
});
